import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';

@Component({
    selector: 'app-historial-whatsapp-dialog',
    templateUrl: './historial-whatsapp-dialog.component.html',
    styleUrls: ['./historial-whatsapp-dialog.component.scss']
})
export class HistorialWhatsappDialogComponent implements OnInit {

    isLoading = true;
    seguimiento: any = null;
    logs: any[] = [];

    constructor(
        public dialogRef: MatDialogRef<HistorialWhatsappDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { idCita: number },
        private gateway: GatewayService
    ) {}

    ngOnInit() {
        this.cargarHistorial();
    }

    cargarHistorial() {
        this.isLoading = true;
        this.gateway.get('historialWhatsappInfructuosa', { idCita: this.data.idCita })
            .then((res: any) => {
                this.isLoading = false;
                if (res && res.response === 1) {
                    this.seguimiento = res.seguimiento;
                    this.logs = res.logs || [];
                }
            })
            .catch((err: any) => {
                this.isLoading = false;
                console.error('[HistorialWhatsappDialog] error:', err);
            });
    }

    getEstadoColor(estado: string): string {
        switch (estado) {
            case 'ACTIVO': return '#FF9800';
            case 'REAGENDADO': return '#4CAF50';
            case 'EXPIRADO': return '#9E9E9E';
            case 'CANCELADO': return '#F44336';
            default: return '#9E9E9E';
        }
    }

    getTipoIcon(tipo: string): string {
        switch (tipo) {
            case 'ENVIO': return 'send';
            case 'RESPUESTA': return 'reply';
            case 'CIERRE': return 'lock';
            case 'REAGENDADO': return 'event_available';
            default: return 'info';
        }
    }

    cerrar(): void {
        this.dialogRef.close();
    }
}
